// Placement and read/edit class only. Backend owns capability metadata.
export const ACCESS_PERMISSION_HIERARCHY = Object.freeze({
  nodes: [
    {
      id: "all-rights",
      title: "Все права",
      kind: "group",
    },
    {
      id: "navigation:dashboard",
      parentId: "all-rights",
      title: "Дашборд",
      kind: "section",
      url: "/",
    },
    {
      id: "home:short_url",
      parentId: "navigation:dashboard",
      title: "Короткие ссылки",
      kind: "group",
    },
    {
      id: "home:oracle",
      parentId: "navigation:dashboard",
      title: "Oracle",
      kind: "group",
    },
    {
      id: "home:cashbox",
      parentId: "navigation:dashboard",
      title: "Касса",
      kind: "group",
    },
    {
      id: "home:promocode_messages",
      parentId: "navigation:dashboard",
      title: "Сообщения промокодов",
      kind: "group",
    },
    {
      id: "home:shop_visits",
      parentId: "navigation:dashboard",
      title: "Посещения магазина",
      kind: "group",
    },
    {
      id: "home:orders",
      parentId: "navigation:dashboard",
      title: "Заказы",
      kind: "group",
    },
    {
      id: "home:oracle_reports",
      parentId: "navigation:dashboard",
      title: "Отчёты Oracle",
      kind: "group",
    },
    {
      id: "menu:modules",
      parentId: "all-rights",
      title: "Модули",
      kind: "section",
      url: "/modules",
    },
    {
      id: "modules:general",
      parentId: "menu:modules",
      title: "Общие модульные права",
      kind: "group",
    },
    {
      id: "modules:pack:G47",
      parentId: "menu:modules",
      title: "Прочее",
      kind: "group",
    },
    {
      id: "module:102",
      parentId: "modules:pack:G47",
      title: "Социальные сети",
      kind: "module",
      moduleId: 102,
      url: "/modules/102",
    },
    {
      id: "module:108",
      parentId: "modules:pack:G47",
      title: "Оценка состояния",
      kind: "module",
      moduleId: 108,
      url: "/modules/108",
    },
    {
      id: "module:122",
      parentId: "modules:pack:G47",
      title: "Подписки",
      kind: "module",
      moduleId: 122,
      url: "/modules/122",
    },
    {
      id: "module:123",
      parentId: "modules:pack:G47",
      title: "Адреса клиентов",
      kind: "module",
      moduleId: 123,
      url: "/modules/123",
    },
    {
      id: "module:125",
      parentId: "modules:pack:G47",
      title: "Расшифровки",
      kind: "module",
      moduleId: 125,
      url: "/modules/125",
    },
    {
      id: "module:127",
      parentId: "modules:pack:G47",
      title: "SMS",
      kind: "module",
      moduleId: 127,
      url: "/modules/127",
    },
    {
      id: "module:131",
      parentId: "modules:pack:G47",
      title: "Письма",
      kind: "module",
      moduleId: 131,
      url: "/modules/131",
    },
    {
      id: "module:139",
      parentId: "modules:pack:G47",
      title: "Папки в 1С (для CD)",
      kind: "module",
      moduleId: 139,
      url: "/modules/139",
    },
    {
      id: "module:153",
      parentId: "modules:pack:G47",
      title: "Тексты-уведомления покупателям",
      kind: "module",
      moduleId: 153,
      url: "/modules/153",
    },
    {
      id: "module:165",
      parentId: "modules:pack:G47",
      title: "Меню на сайте",
      kind: "module",
      moduleId: 165,
      url: "/modules/165",
    },
    {
      id: "modules:pack:G48",
      parentId: "menu:modules",
      title: "Помощь",
      kind: "group",
    },
    {
      id: "module:103",
      parentId: "modules:pack:G48",
      title: "Блоки",
      kind: "module",
      moduleId: 103,
      url: "/modules/103",
    },
    {
      id: "module:104",
      parentId: "modules:pack:G48",
      title: "Тексты",
      kind: "module",
      moduleId: 104,
      url: "/modules/104",
    },
    {
      id: "module:111",
      parentId: "modules:pack:G48",
      title: "Сообщения",
      kind: "module",
      moduleId: 111,
      url: "/modules/111",
    },
    {
      id: "module:118",
      parentId: "modules:pack:G48",
      title: "Запросы на оракул",
      kind: "module",
      moduleId: 118,
      url: "/modules/118",
    },
    {
      id: "modules:pack:G49",
      parentId: "menu:modules",
      title: "Публикации",
      kind: "group",
    },
    {
      id: "module:105",
      parentId: "modules:pack:G49",
      title: "Новости",
      kind: "module",
      moduleId: 105,
      url: "/modules/105",
    },
    {
      id: "module:106",
      parentId: "modules:pack:G49",
      title: "Контакты",
      kind: "module",
      moduleId: 106,
      url: "/modules/106",
    },
    {
      id: "module:130",
      parentId: "modules:pack:G49",
      title: "Небольшие тексты",
      kind: "module",
      moduleId: 130,
      url: "/modules/130",
    },
    {
      id: "module:137",
      parentId: "modules:pack:G49",
      title: "Новостная полоса",
      kind: "module",
      moduleId: 137,
      url: "/modules/137",
    },
    {
      id: "module:141",
      parentId: "modules:pack:G49",
      title: "Статьи",
      kind: "module",
      moduleId: 141,
      url: "/modules/141",
    },
    {
      id: "module:152",
      parentId: "modules:pack:G49",
      title: "Сеты",
      kind: "module",
      moduleId: 152,
      url: "/modules/152",
    },
    {
      id: "module:154",
      parentId: "modules:pack:G49",
      title: "Кинорекомендации",
      kind: "module",
      moduleId: 154,
      url: "/modules/154",
    },
    {
      id: "modules:pack:G50",
      parentId: "menu:modules",
      title: "Каталог",
      kind: "group",
    },
    {
      id: "module:112",
      parentId: "modules:pack:G50",
      title: "CD",
      kind: "module",
      moduleId: 112,
      url: "/modules/112",
    },
    {
      id: "module:115",
      parentId: "modules:pack:G50",
      title: "LP",
      kind: "module",
      moduleId: 115,
      url: "/modules/115",
    },
    {
      id: "module:117",
      parentId: "modules:pack:G50",
      title: "Аксессуары",
      kind: "module",
      moduleId: 117,
      url: "/modules/117",
    },
    {
      id: "module:143",
      parentId: "modules:pack:G50",
      title: "Поставщики",
      kind: "module",
      moduleId: 143,
      url: "/modules/143",
    },
    {
      id: "module:149",
      parentId: "modules:pack:G50",
      title: "LP Special",
      kind: "module",
      moduleId: 149,
      url: "/modules/149",
    },
    {
      id: "module:160",
      parentId: "modules:pack:G50",
      title: "Будущие товары",
      kind: "module",
      moduleId: 160,
      url: "/modules/160",
    },
    {
      id: "module:164",
      parentId: "modules:pack:G50",
      title: "Апдейт новых поступлений",
      kind: "module",
      moduleId: 164,
      url: "/modules/164",
    },
    {
      id: "module:167",
      parentId: "modules:pack:G50",
      title: "CD Special",
      kind: "module",
      moduleId: 167,
      url: "/modules/167",
    },
    {
      id: "modules:pack:G51",
      parentId: "menu:modules",
      title: "Продажи",
      kind: "group",
    },
    {
      id: "module:120",
      parentId: "modules:pack:G51",
      title: "Способы оплаты",
      kind: "module",
      moduleId: 120,
      url: "/modules/120",
    },
    {
      id: "module:121",
      parentId: "modules:pack:G51",
      title: "Способы доставки",
      kind: "module",
      moduleId: 121,
      url: "/modules/121",
    },
    {
      id: "module:128",
      parentId: "modules:pack:G51",
      title: "Статусы заказа",
      kind: "module",
      moduleId: 128,
      url: "/modules/128",
    },
    {
      id: "module:129",
      parentId: "modules:pack:G51",
      title: "Менеджеры",
      kind: "module",
      moduleId: 129,
      url: "/modules/129",
    },
    {
      id: "module:142",
      parentId: "modules:pack:G51",
      title: "Скидки",
      kind: "module",
      moduleId: 142,
      url: "/modules/142",
    },
    {
      id: "module:146",
      parentId: "modules:pack:G51",
      title: "Промо-коды",
      kind: "module",
      moduleId: 146,
      url: "/modules/146",
    },
    {
      id: "module:150",
      parentId: "modules:pack:G51",
      title: "ID заказов СДЭК",
      kind: "module",
      moduleId: 150,
      url: "/modules/150",
    },
    {
      id: "modules:pack:G52",
      parentId: "menu:modules",
      title: "Библиотеки",
      kind: "group",
    },
    {
      id: "module:107",
      parentId: "modules:pack:G52",
      title: "Лейблы",
      kind: "module",
      moduleId: 107,
      url: "/modules/107",
    },
    {
      id: "module:109",
      parentId: "modules:pack:G52",
      title: "Артисты",
      kind: "module",
      moduleId: 109,
      url: "/modules/109",
    },
    {
      id: "module:110",
      parentId: "modules:pack:G52",
      title: "Стили/жанры",
      kind: "module",
      moduleId: 110,
      url: "/modules/110",
    },
    {
      id: "module:113",
      parentId: "modules:pack:G52",
      title: "Страны",
      kind: "module",
      moduleId: 113,
      url: "/modules/113",
    },
    {
      id: "module:114",
      parentId: "modules:pack:G52",
      title: "Тэги",
      kind: "module",
      moduleId: 114,
      url: "/modules/114",
    },
    {
      id: "module:116",
      parentId: "modules:pack:G52",
      title: "Категории аксуссуаров",
      kind: "module",
      moduleId: 116,
      url: "/modules/116",
    },
    {
      id: "module:124",
      parentId: "modules:pack:G52",
      title: "Размеры пластинки",
      kind: "module",
      moduleId: 124,
      url: "/modules/124",
    },
    {
      id: "module:126",
      parentId: "modules:pack:G52",
      title: "Youtube-ролики",
      kind: "module",
      moduleId: 126,
      url: "/modules/126",
    },
    {
      id: "module:132",
      parentId: "modules:pack:G52",
      title: "Упаковка CD",
      kind: "module",
      moduleId: 132,
      url: "/modules/132",
    },
    {
      id: "module:133",
      parentId: "modules:pack:G52",
      title: "Типы CD",
      kind: "module",
      moduleId: 133,
      url: "/modules/133",
    },
    {
      id: "module:138",
      parentId: "modules:pack:G52",
      title: "Дополнения для альбомов LP",
      kind: "module",
      moduleId: 138,
      url: "/modules/138",
    },
    {
      id: "module:140",
      parentId: "modules:pack:G52",
      title: "Комментарии к LP",
      kind: "module",
      moduleId: 140,
      url: "/modules/140",
    },
    {
      id: "module:155",
      parentId: "modules:pack:G52",
      title: "Дополнения для альбомов CD",
      kind: "module",
      moduleId: 155,
      url: "/modules/155",
    },
    {
      id: "modules:pack:G53",
      parentId: "menu:modules",
      title: "О магазине",
      kind: "group",
    },
    {
      id: "module:1",
      parentId: "modules:pack:G53",
      title: "Параметры",
      kind: "module",
      moduleId: 1,
      url: "/modules/1",
    },
    {
      id: "module:134",
      parentId: "modules:pack:G53",
      title: "Сотрудники",
      kind: "module",
      moduleId: 134,
      url: "/modules/134",
    },
    {
      id: "module:135",
      parentId: "modules:pack:G53",
      title: "Знаменитости",
      kind: "module",
      moduleId: 135,
      url: "/modules/135",
    },
    {
      id: "module:136",
      parentId: "modules:pack:G53",
      title: "Отзывы",
      kind: "module",
      moduleId: 136,
      url: "/modules/136",
    },
    {
      id: "menu:users",
      parentId: "all-rights",
      title: "Пользователи",
      kind: "section",
      url: "/users",
    },
    {
      id: "users:accounts",
      parentId: "menu:users",
      title: "Список и карточки пользователей",
      kind: "group",
      url: "/users",
    },
    {
      id: "menu:pages",
      parentId: "all-rights",
      title: "Страницы",
      kind: "section",
      url: "/pages",
    },
    {
      id: "pages:cards",
      parentId: "menu:pages",
      title: "Список и карточки страниц",
      kind: "group",
      url: "/pages",
    },
    {
      id: "menu:options",
      parentId: "all-rights",
      title: "Параметры",
      kind: "section",
      url: "/options",
    },
    {
      id: "menu:access",
      parentId: "all-rights",
      title: "Доступ",
      kind: "section",
      url: "/access",
    },
    {
      id: "access:roles",
      parentId: "menu:access",
      title: "Роли",
      kind: "group",
      url: "/access/roles",
    },
    {
      id: "access:assignments",
      parentId: "menu:access",
      title: "Назначения",
      kind: "group",
      url: "/access/admins",
    },
    {
      id: "access:system",
      parentId: "menu:access",
      title: "Системный административный доступ",
      kind: "group",
    },
    {
      id: "menu:reports",
      parentId: "all-rights",
      title: "Отчёты",
      kind: "section",
      url: "/reports",
    },
    {
      id: "reports:add_copies",
      parentId: "menu:reports",
      title: "добавленные экземпляры",
      kind: "group",
    },
    {
      id: "reports:artists",
      parentId: "menu:reports",
      title: "Карточки артистов",
      kind: "group",
    },
    {
      id: "reports:bertus",
      parentId: "menu:reports",
      title: "поставщик Bertus",
      kind: "group",
    },
    {
      id: "reports:boxes_minus",
      parentId: "menu:reports",
      title: "Минус по коробкам",
      kind: "group",
    },
    {
      id: "reports:cashbox",
      parentId: "menu:reports",
      title: "Списания с кассы",
      kind: "group",
    },
    {
      id: "reports:cd_copies",
      parentId: "menu:reports",
      title: "экземпляры CD",
      kind: "group",
    },
    {
      id: "reports:checks",
      parentId: "menu:reports",
      title: "чеки",
      kind: "group",
    },
    {
      id: "reports:emails_qty",
      parentId: "menu:reports",
      title: "количество электронных адресов",
      kind: "group",
    },
    {
      id: "reports:emails_stat",
      parentId: "menu:reports",
      title: "статистика электронных адресов",
      kind: "group",
    },
    {
      id: "reports:favorites",
      parentId: "menu:reports",
      title: "избранное",
      kind: "group",
    },
    {
      id: "reports:full_cat",
      parentId: "menu:reports",
      title: "Полный каталог",
      kind: "group",
    },
    {
      id: "reports:logs",
      parentId: "menu:reports",
      title: "журнал действий",
      kind: "group",
    },
    {
      id: "reports:lp_no_keys",
      parentId: "menu:reports",
      title: "LP без ключей",
      kind: "group",
    },
    {
      id: "reports:markets",
      parentId: "menu:reports",
      title: "маркетплейсы",
      kind: "group",
    },
    {
      id: "reports:meshok",
      parentId: "menu:reports",
      title: "Мешок",
      kind: "group",
    },
    {
      id: "reports:orders",
      parentId: "menu:reports",
      title: "Заказы",
      kind: "group",
    },
    {
      id: "reports:photo_1c_copies",
      parentId: "menu:reports",
      title: "фото экземпляров из 1С",
      kind: "group",
    },
    {
      id: "reports:photo_lp",
      parentId: "menu:reports",
      title: "Фото LP",
      kind: "group",
    },
    {
      id: "reports:preorders",
      parentId: "menu:reports",
      title: "Предзаказы",
      kind: "group",
    },
    {
      id: "reports:product_sale_log",
      parentId: "menu:reports",
      title: "журнал продаж товаров",
      kind: "group",
    },
    {
      id: "reports:repeated_products",
      parentId: "menu:reports",
      title: "Повторяющиеся товары",
      kind: "group",
    },
    {
      id: "reports:sales",
      parentId: "menu:reports",
      title: "Продажи",
      kind: "group",
    },
    {
      id: "reports:sales_speed",
      parentId: "menu:reports",
      title: "Скорость продаж",
      kind: "group",
    },
    {
      id: "reports:search",
      parentId: "menu:reports",
      title: "поисковые запросы",
      kind: "group",
    },
    {
      id: "reports:special",
      parentId: "menu:reports",
      title: "специальный каталог",
      kind: "group",
    },
    {
      id: "reports:store_pickup",
      parentId: "menu:reports",
      title: "Забрать со склада",
      kind: "group",
    },
    {
      id: "reports:top_artists",
      parentId: "menu:reports",
      title: "Топ-артисты",
      kind: "group",
    },
    {
      id: "menu:seo",
      parentId: "all-rights",
      title: "SEO",
      kind: "section",
      url: "/seo",
    },
    {
      id: "menu:carts",
      parentId: "all-rights",
      title: "Корзины",
      kind: "section",
      url: "/carts",
    },
    {
      id: "menu:services",
      parentId: "all-rights",
      title: "Сервисы",
      kind: "section",
    },
    {
      id: "services:compare_1c",
      parentId: "menu:services",
      title: "Сверка 1С",
      kind: "group",
      url: "/services/compare_1c",
    },
    {
      id: "services:sales_1c",
      parentId: "menu:services",
      title: "Списание 1С",
      kind: "group",
      url: "/services/sales_1c",
    },
    {
      id: "services:prices",
      parentId: "menu:services",
      title: "Обновление цен",
      kind: "group",
      url: "/services/prices",
    },
    {
      id: "services:emails",
      parentId: "menu:services",
      title: "Выгрузка Emails",
      kind: "group",
      url: "/services/emails",
    },
    {
      id: "services:revaluation",
      parentId: "menu:services",
      title: "Переоценка",
      kind: "group",
      url: "/services/revaluation",
    },
    {
      id: "services:tag_sync",
      parentId: "menu:services",
      title: "Обновление тегов",
      kind: "group",
      url: "/services/tag_sync",
    },
    {
      id: "services:refresh",
      parentId: "menu:services",
      title: "Новые поступления",
      kind: "group",
      url: "/services/refresh",
    },
    {
      id: "services:artist_change",
      parentId: "menu:services",
      title: "Замена артистов",
      kind: "group",
      url: "/services/artist_change",
    },
    {
      id: "services:market_price",
      parentId: "menu:services",
      title: "Цены на маркетах",
      kind: "group",
      url: "/services/market_price",
    },
  ],
  rights: [
    {
      code: "carts.view",
      class: "read",
      placements: ["menu:carts"],
    },
    {
      code: "catalog.create",
      class: "edit",
      placements: [
        "modules:general",
        "module:102",
        "module:108",
        "module:122",
        "module:123",
        "module:125",
        "module:127",
        "module:131",
        "module:139",
        "module:153",
        "module:165",
        "module:103",
        "module:104",
        "module:111",
        "module:118",
        "module:105",
        "module:106",
        "module:130",
        "module:137",
        "module:141",
        "module:152",
        "module:154",
        "module:112",
        "module:115",
        "module:117",
        "module:143",
        "module:149",
        "module:160",
        "module:164",
        "module:167",
        "module:120",
        "module:121",
        "module:128",
        "module:129",
        "module:142",
        "module:146",
        "module:150",
        "module:107",
        "module:109",
        "module:110",
        "module:113",
        "module:114",
        "module:116",
        "module:124",
        "module:126",
        "module:132",
        "module:133",
        "module:138",
        "module:140",
        "module:155",
        "module:1",
        "module:134",
        "module:135",
        "module:136",
      ],
    },
    {
      code: "catalog.delete",
      class: "edit",
      placements: [
        "modules:general",
        "module:102",
        "module:108",
        "module:122",
        "module:123",
        "module:125",
        "module:127",
        "module:131",
        "module:139",
        "module:153",
        "module:165",
        "module:103",
        "module:104",
        "module:111",
        "module:118",
        "module:105",
        "module:106",
        "module:130",
        "module:137",
        "module:141",
        "module:152",
        "module:154",
        "module:112",
        "module:115",
        "module:117",
        "module:143",
        "module:149",
        "module:160",
        "module:164",
        "module:167",
        "module:120",
        "module:121",
        "module:128",
        "module:129",
        "module:142",
        "module:146",
        "module:150",
        "module:107",
        "module:109",
        "module:110",
        "module:113",
        "module:114",
        "module:116",
        "module:124",
        "module:126",
        "module:132",
        "module:133",
        "module:138",
        "module:140",
        "module:155",
        "module:1",
        "module:134",
        "module:135",
        "module:136",
      ],
    },
    {
      code: "catalog.edit_1c",
      class: "edit",
      placements: [
        "modules:general",
        "module:112",
        "module:115",
        "module:117",
        "module:167",
      ],
    },
    {
      code: "catalog.edit_media",
      class: "edit",
      placements: [
        "modules:general",
        "module:105",
        "module:109",
        "module:112",
        "module:115",
        "module:117",
        "module:134",
        "module:135",
        "module:141",
        "module:149",
        "module:167",
      ],
    },
    {
      code: "catalog.edit_prices",
      class: "edit",
      placements: [
        "modules:general",
        "module:112",
        "module:115",
        "module:117",
        "module:149",
        "module:160",
        "module:167",
        "module:120",
        "module:121",
        "module:142",
        "module:146",
      ],
    },
    {
      code: "catalog.export_excel",
      class: "read",
      placements: [
        "modules:general",
        "module:102",
        "module:108",
        "module:122",
        "module:123",
        "module:125",
        "module:127",
        "module:131",
        "module:139",
        "module:153",
        "module:165",
        "module:103",
        "module:104",
        "module:111",
        "module:118",
        "module:105",
        "module:106",
        "module:130",
        "module:137",
        "module:141",
        "module:152",
        "module:154",
        "module:112",
        "module:115",
        "module:117",
        "module:143",
        "module:149",
        "module:160",
        "module:164",
        "module:167",
        "module:120",
        "module:121",
        "module:128",
        "module:129",
        "module:142",
        "module:146",
        "module:150",
        "module:107",
        "module:109",
        "module:110",
        "module:113",
        "module:114",
        "module:116",
        "module:124",
        "module:126",
        "module:132",
        "module:133",
        "module:138",
        "module:140",
        "module:155",
        "module:1",
        "module:134",
        "module:135",
        "module:136",
      ],
    },
    {
      code: "catalog.publish",
      class: "edit",
      placements: [
        "modules:general",
        "module:102",
        "module:108",
        "module:122",
        "module:123",
        "module:125",
        "module:127",
        "module:131",
        "module:139",
        "module:153",
        "module:165",
        "module:103",
        "module:104",
        "module:111",
        "module:118",
        "module:105",
        "module:106",
        "module:130",
        "module:137",
        "module:141",
        "module:152",
        "module:154",
        "module:112",
        "module:115",
        "module:117",
        "module:143",
        "module:149",
        "module:160",
        "module:164",
        "module:167",
        "module:120",
        "module:121",
        "module:128",
        "module:129",
        "module:142",
        "module:146",
        "module:150",
        "module:107",
        "module:109",
        "module:110",
        "module:113",
        "module:114",
        "module:116",
        "module:124",
        "module:126",
        "module:132",
        "module:133",
        "module:138",
        "module:140",
        "module:155",
        "module:1",
        "module:134",
        "module:135",
        "module:136",
      ],
    },
    {
      code: "dashboard.cashbox",
      class: "edit",
      placements: ["home:cashbox"],
    },
    {
      code: "dashboard.oracle",
      class: "edit",
      placements: ["home:oracle"],
    },
    {
      code: "dashboard.oracle_reports",
      class: "read",
      placements: ["home:oracle_reports"],
    },
    {
      code: "dashboard.promocode_messages",
      class: "read",
      placements: ["home:promocode_messages"],
    },
    {
      code: "dashboard.short_url",
      class: "edit",
      placements: ["home:short_url"],
    },
    {
      code: "modules.edit",
      class: "edit",
      placements: ["menu:modules"],
    },
    {
      code: "modules.structure.manage",
      class: "edit",
      placements: ["menu:modules"],
    },
    {
      code: "modules.view",
      class: "read",
      placements: ["menu:modules"],
    },
    {
      code: "oracle.skip",
      class: "edit",
      placements: ["home:oracle"],
    },
    {
      code: "orders.change_manager",
      class: "edit",
      placements: ["home:orders"],
    },
    {
      code: "orders.change_package_status",
      class: "edit",
      placements: ["home:orders"],
    },
    {
      code: "orders.create_custom",
      class: "edit",
      placements: ["home:orders"],
    },
    {
      code: "orders.edit.basic",
      class: "edit",
      placements: ["home:orders"],
    },
    {
      code: "orders.edit.financials",
      class: "edit",
      placements: ["home:orders"],
    },
    {
      code: "orders.edit.workflow",
      class: "edit",
      placements: ["home:orders"],
    },
    {
      code: "orders.oracle_response",
      class: "edit",
      placements: ["home:orders"],
    },
    {
      code: "orders.send_tracking",
      class: "edit",
      placements: ["home:orders"],
    },
    {
      code: "orders.view",
      class: "read",
      placements: ["home:orders"],
    },
    {
      code: "pages.edit",
      class: "edit",
      placements: ["pages:cards"],
    },
    {
      code: "pages.view",
      class: "read",
      placements: ["pages:cards"],
    },
    {
      code: "reports.named.add_copies",
      class: "read",
      placements: ["reports:add_copies"],
    },
    {
      code: "reports.named.artists",
      class: "read",
      placements: ["reports:artists"],
    },
    {
      code: "reports.named.bertus",
      class: "read",
      placements: ["reports:bertus"],
    },
    {
      code: "reports.named.boxes_minus",
      class: "read",
      placements: ["reports:boxes_minus"],
    },
    {
      code: "reports.named.cashbox",
      class: "read",
      placements: ["reports:cashbox"],
    },
    {
      code: "reports.named.cd_copies",
      class: "read",
      placements: ["reports:cd_copies"],
    },
    {
      code: "reports.named.checks",
      class: "read",
      placements: ["reports:checks"],
    },
    {
      code: "reports.named.emails_qty",
      class: "read",
      placements: ["reports:emails_qty"],
    },
    {
      code: "reports.named.emails_stat",
      class: "read",
      placements: ["reports:emails_stat"],
    },
    {
      code: "reports.named.favorites",
      class: "read",
      placements: ["reports:favorites"],
    },
    {
      code: "reports.named.full_cat",
      class: "read",
      placements: ["reports:full_cat"],
    },
    {
      code: "reports.named.logs",
      class: "read",
      placements: ["reports:logs"],
    },
    {
      code: "reports.named.lp_no_keys",
      class: "read",
      placements: ["reports:lp_no_keys"],
    },
    {
      code: "reports.named.markets",
      class: "read",
      placements: ["reports:markets"],
    },
    {
      code: "reports.named.meshok",
      class: "read",
      placements: ["reports:meshok"],
    },
    {
      code: "reports.named.orders",
      class: "read",
      placements: ["reports:orders"],
    },
    {
      code: "reports.named.photo_1c_copies",
      class: "read",
      placements: ["reports:photo_1c_copies"],
    },
    {
      code: "reports.named.photo_lp",
      class: "read",
      placements: ["reports:photo_lp"],
    },
    {
      code: "reports.named.preorders",
      class: "read",
      placements: ["reports:preorders"],
    },
    {
      code: "reports.named.product_sale_log",
      class: "read",
      placements: ["reports:product_sale_log"],
    },
    {
      code: "reports.named.repeated_products",
      class: "read",
      placements: ["reports:repeated_products"],
    },
    {
      code: "reports.named.sales",
      class: "read",
      placements: ["reports:sales"],
    },
    {
      code: "reports.named.sales_speed",
      class: "read",
      placements: ["reports:sales_speed"],
    },
    {
      code: "reports.named.search",
      class: "read",
      placements: ["reports:search"],
    },
    {
      code: "reports.named.special",
      class: "read",
      placements: ["reports:special"],
    },
    {
      code: "reports.named.store_pickup",
      class: "read",
      placements: ["reports:store_pickup"],
    },
    {
      code: "reports.named.top_artists",
      class: "read",
      placements: ["reports:top_artists"],
    },
    {
      code: "roles.manage",
      class: "edit",
      placements: ["access:roles", "access:assignments"],
    },
    {
      code: "roles.view",
      class: "read",
      placements: ["access:roles"],
    },
    {
      code: "seo.edit",
      class: "edit",
      placements: ["menu:seo"],
    },
    {
      code: "seo.view",
      class: "read",
      placements: ["menu:seo"],
    },
    {
      code: "services.artist_change",
      class: "edit",
      placements: ["services:artist_change"],
    },
    {
      code: "services.compare_1c",
      class: "edit",
      placements: ["services:compare_1c"],
    },
    {
      code: "services.emails",
      class: "edit",
      placements: ["services:emails"],
    },
    {
      code: "services.market_price",
      class: "edit",
      placements: ["services:market_price"],
    },
    {
      code: "services.prices",
      class: "edit",
      placements: ["services:prices"],
    },
    {
      code: "services.refresh",
      class: "edit",
      placements: ["services:refresh"],
    },
    {
      code: "services.revaluation",
      class: "edit",
      placements: ["services:revaluation"],
    },
    {
      code: "services.tag_sync",
      class: "edit",
      placements: ["services:tag_sync"],
    },
    {
      code: "services.sales_1c",
      class: "edit",
      placements: ["services:sales_1c"],
    },
    {
      code: "system.admin.login",
      class: "edit",
      placements: ["access:system"],
    },
    {
      code: "system.files.edit",
      class: "edit",
      placements: ["access:system"],
    },
    {
      code: "system.langs.edit",
      class: "edit",
      placements: ["access:system"],
    },
    {
      code: "system.options.edit",
      class: "edit",
      placements: ["menu:options"],
    },
    {
      code: "system.options.view",
      class: "read",
      placements: ["menu:options"],
    },
    {
      code: "users.edit",
      class: "edit",
      placements: ["users:accounts"],
    },
    {
      code: "users.export",
      class: "read",
      placements: ["users:accounts"],
    },
    {
      code: "users.impersonate",
      class: "edit",
      placements: ["users:accounts"],
    },
    {
      code: "users.view",
      class: "read",
      placements: ["users:accounts"],
    },
  ],
})
